export default {
    methods: {
        formatNumber(number) {
            return Number.parseFloat(number).toFixed(2);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/number-format.js